function getQueryParam(key: string): string | null {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get(key);
}

function isRedeemGiftPage(): boolean {
  return window.location.pathname.startsWith('/redeem_signup/gift');
}

function objectToQueryParams(params: Record<string, unknown>): URLSearchParams {
  const normalizedObject: Record<string, string> = {};

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }
    // @ts-expect-error TODO: fix null safety
    normalizedObject[key] = value.toString();
  });

  return new URLSearchParams(Object.entries(normalizedObject));
}

export { getQueryParam, isRedeemGiftPage, objectToQueryParams };
